/* eslint-disable @wyz/module/no-relative-import */
import { useAuth } from 'react-oidc-context';
import AuthenticatedApp from './authenticated-app';
import UnAuthenticatedApp from './unauthenticated-app';

const AppRouter = () => {
  const auth = useAuth();
  if (auth.isAuthenticated) {
    return <AuthenticatedApp />;
  }
  return <UnAuthenticatedApp />;
};

export default AppRouter;
